module.exports = __webpack_public_path__ + "img/losaprily-card-banner.9490da72.png";